import {$$} from '@vue-macros/reactivity-transform/macros'

import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {
  IDatabaseGroupItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'

export function useListPropertyTypeStrategy() {

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItemResponseInstance, showAllDatabaseGroups: boolean): IFilter => {
    const value = groupItem?.value ?? null
    const buildEmptyItem = (operator: FilterPropertyOperator.Empty | FilterPropertyOperator.ArrayEmpty) => ({
      type: FilterItemType.Property,
      id: group,
      operator: {
        type: operator,
      },
      subProperty: null,
      payload: {
        type: FilterPropertyPayloadType.Static,
        value: null,
      },
      isDisabled: false,
    })
    if(value === null) {
      if(!showAllDatabaseGroups) {
        return buildEmptyItem(FilterPropertyOperator.Empty) as IFilter
      }
      return {
        type: FilterItemType.Group,
        operator: FilterGroupOperator.Or,
        items: [
          buildEmptyItem(FilterPropertyOperator.Empty),
          buildEmptyItem(FilterPropertyOperator.ArrayEmpty),
        ],
      } as IFilter
    }
    return {
      type: FilterItemType.Property,
      id: group,
      operator: {
        type: !showAllDatabaseGroups ? FilterPropertyOperator.Equals : FilterPropertyOperator.ArrayIncludes,
        options: {
          isCaseSensitive: true,
        },
      },
      subProperty: null,
      payload: {
        type: FilterPropertyPayloadType.Static,
        value,
      },
      isDisabled: false,
    }
  }

  return $$({
    getGroupFilter,
  })
}

